import { render, staticRenderFns } from "./ReportsFees.vue?vue&type=template&id=4d5d9932&scoped=true&"
import script from "./ReportsFees.vue?vue&type=script&lang=js&"
export * from "./ReportsFees.vue?vue&type=script&lang=js&"
import style0 from "./ReportsFees.vue?vue&type=style&index=0&id=4d5d9932&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5d9932",
  null
  
)

export default component.exports